import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {LoginService} from "./login.service";

@NgModule({
  providers: [LoginService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginModule {
}
